import React, { useEffect, useState } from "react"
import { Search } from "lucide-react"
import { fetchVariables } from "../api/templatesApi"

// Searchable, grouped variable palette. Clicking a variable calls onInsert with
// the Liquid token (e.g. "{{ lead.first_name }}") for insertion at the cursor.
export function VariableInserter({ category, onInsert }) {
  const [groups, setGroups] = useState({})
  const [query, setQuery] = useState("")

  useEffect(() => {
    if (!category) return
    fetchVariables(category).then(setGroups).catch(() => setGroups({}))
  }, [category])

  const q = query.trim().toLowerCase()

  return (
    <div className="flex h-full flex-col rounded-lg border border-slate-200 bg-slate-50/50">
      <div className="border-b border-slate-100 p-2">
        <div className="relative">
          <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search variables…"
            className="w-full rounded-md border border-slate-200 bg-white py-1.5 pl-8 pr-2 text-[12px] outline-none focus:border-slate-300"
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-2">
        {Object.entries(groups).map(([group, vars]) => {
          const filtered = vars.filter(
            (v) => !q || v.key.toLowerCase().includes(q) || v.label.toLowerCase().includes(q)
          )
          if (filtered.length === 0) return null
          return (
            <div key={group} className="mb-3">
              <p className="mb-1 px-1 text-[10px] font-bold uppercase tracking-wider text-slate-400">{group}</p>
              <div className="space-y-0.5">
                {filtered.map((v) => (
                  <button
                    key={v.key}
                    type="button"
                    onClick={() => onInsert(`{{ ${v.key} }}`)}
                    title={`Insert {{ ${v.key} }}`}
                    className="flex w-full flex-col items-start rounded-md px-2 py-1 text-left transition-colors hover:bg-white"
                  >
                    <span className="font-mono text-[11px] text-slate-700">{`{{ ${v.key} }}`}</span>
                    <span className="text-[10px] text-slate-400">{v.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )
        })}
        {Object.keys(groups).length === 0 && (
          <p className="px-1 text-[12px] text-slate-400">Pick a category to see variables.</p>
        )}
      </div>
    </div>
  )
}
